export default __webpack_public_path__ + "images/N7.7e7a206.png";